import { ASSETS_BASE_URL } from '../data/Constants';
import { IMedia } from '../interfaces/content/IMedia';
import {
  ILandingPageResponse,
  IMenuAccountResponse
} from '../interfaces/content/IPage';
import contentClient from '../provider/contentProvider';
import { getMostWatched } from './maisSbt';

export function formatImageUrl(image: IMedia | undefined): string {
  if (!image) return '';
  return `${ASSETS_BASE_URL}/${image?.hash}${image?.ext}`;
}

export async function getLandingPage(): Promise<ILandingPageResponse> {
  const response = await contentClient.get('/landing-page');
  return response?.data;
}

export async function getMenuAccountPage(): Promise<IMenuAccountResponse> {
  const response = await contentClient.get('/account-menu');
  const res: IMenuAccountResponse = response?.data;

  for (let idx = 0; idx < res.carousel.length; idx++) {
    const carousel = res.carousel[idx];

    if (carousel.type === 'maissbt') {
      const playlist = await getMostWatched();

      res.carousel[idx].items = playlist?.videos?.map((v) => ({
        title: v.name,
        description: `${v?.custom_fields?.release_year} - ${v?.episodeCount} Episódios`,
        thumbnailUrl: `https://stream.maissbt.com${v?.custom_fields?.horizontal_card}`,
        url: `https://mais.sbt.com.br/show/${v?.id}`,
        icon:
          v?.custom_fields?.parental_rating === 'SC'
            ? ''
            : `age${v?.custom_fields?.parental_rating}`
      }));
    }
  }

  return res;
}
